import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@journal/env/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private baseUrl = `${environment.baseUrl}`;
  searchedDiscipline: any;

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = `${environment.serverUrl}${this.baseUrl}`;
  }

  getBlogTypes() {
    return this.http.get(this.baseUrl + 'super_tags/?type=Blog Type');
  }

  getDisciplines() {
    return this.http.get(this.baseUrl + 'super_tags/all_disciplines/');
  }

  setSearchDiscipline(discipline) {
    this.searchedDiscipline = discipline;
  }

  getSearchDiscipline() {
    return this.searchedDiscipline;
  }

  getFilteredBlogs(
    page: number,
    search_text: string,
    discipline_ids: string,
    journalType_id: string,
    order: string,
    date_range: string,
    username: string,
    reference: string,
    editorial: boolean = false
  ) {
    return this.http.get(
      this.baseUrl + 'blogs/?page=' + page +
      '&search=' + search_text +
      '&disciplines=' + discipline_ids +
      '&types=' + journalType_id +
      '&ordering=' + order +
      '&date_range=' + date_range +
      '&username=' + username +
      '&references=' + reference + 
      `${editorial ? `&editorial=${editorial}` : ''}`);
  }
}
